'use client';

import { HStack } from '@chakra-ui/react';
import { useRef } from 'react';
import CategoryLink from './Link';
import { ICategoryWithProducts } from '@/features/brand-menu';
import Filters from './Filters';

interface IProps {
  data: ICategoryWithProducts[] | undefined;
  active?: ICategoryWithProducts;
}

function StaticBar({ data }: IProps) {
  const catalogRef = useRef<any>(null);
  return (
    <>
      <HStack
        gap={{ base: 1, lg: 4 }}
        maxWidth="100%"
        ref={catalogRef}
        pt={{ base: 4, md: 8 }}
        flexWrap={{ base: 'nowrap', md: 'wrap' }}
        overflowX={{ base: 'auto', md: 'visible' }}
        scrollbar={'hidden'}
        align="stretch"
      >
        <Filters />
        {data?.map((item, idx) => (
          <CategoryLink
            category={item}
            active={idx === 0}
            key={`${item.id}-${item.slug}-${idx}`}
          />
        ))}
      </HStack>
    </>
  );
}

export default StaticBar;
